export default {
 /* -------------------------------------------------------------------------- */
 /*                                 List State                                 */
 /* -------------------------------------------------------------------------- */
 loading: false,
 listLoading: false,
 orderLoading:false,
 orderList: {},
 OrderRecords: [],
 total: 0,
 FilteredCount: 0,
 OrderAnalytics: {
  totalAmount: 0,
  totalCount: 0
 }
}
